import React from 'react'

import { Tab } from 'react-bootstrap'

/**
 * @param {{
 *    title: string
 *    eventKey: string
 * }} props
 * @returns {React.Component}
 */
const ZariTab = ({ eventKey, title, ...props }) => {
  return <Tab eventKey={eventKey} title={title} {...props} />
}

export default ZariTab
